export default "__VITE_ASSET__DbcCmp4x__"